import * as React from 'react';
const { connect } = require('react-redux');
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
import { closeModal } from 'modules/modal';
import * as c from 'models/constants';
import { Modal } from 'components';
import { IModalAction } from 'models/modal';
import { SearchInput } from 'components';
import { ISearchAction, ISearchData } from 'models/search/search';
import { setSearchKeyword } from 'redux/modules/search/search';
import { browserHistory } from 'react-router';
require('./style.css');

interface IProps {
	showHeaderCloseButton?: boolean;
	search?: ISearchData;

	/* function props */
	closeModal?: () => IModalAction;
	t?: (key: string) => string;
	setSearchKeyword?: (keyword: string) => ISearchAction;
}

@connect(
	(state: IStore) => ({
		search: state.search,
	}),
	(dispatch) => ({
		closeModal: () => dispatch(closeModal()),
		setSearchKeyword: (keyword: string) => dispatch(setSearchKeyword(keyword)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class SearchPopup extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.handleSearchEnterPress = this.handleSearchEnterPress.bind(this);
		this.handleSearchValueChange = this.handleSearchValueChange.bind(this);
	}

	private handleSearchEnterPress(event: any) {
		if (event.key === 'Enter') {
			if (this.props.search.keyword.length > 2) {
				this.props.setSearchKeyword(this.props.search.keyword);
				this.props.closeModal();
				browserHistory.push('/search/' + encodeURIComponent(this.props.search.keyword));
			}
		}
	}

	private handleSearchValueChange(e: any) {
		const value: string = e.target.value;
		this.props.setSearchKeyword(value.length > 0 ? value : '');
	}

	public render() {
		const { /*t,*/ showHeaderCloseButton } = this.props;
		const { keyword } = this.props.search;

		const searchInputProps = {
			keyword,
			onSearchEnterPress: this.handleSearchEnterPress,
			onSearchValueChange: this.handleSearchValueChange,
			onClearSearchInput: () => {
				this.props.setSearchKeyword('');
			},
		};

		return (
			<Modal
				showHeaderCloseButton={showHeaderCloseButton}
				closeModal={this.props.closeModal}
				modalClass="searchPopupContainer"
			>
				<div className="leftWallpaper" />
				<div className="searchModalContent">
					<div className="closeIcon" onClick={this.props.closeModal} />
					<div className="centeredContent">
						<div className="searchHeader">
							<img src={require('./../../Html/images/logo/glossiq.svg')} />
						</div>
						<SearchInput {...searchInputProps} />
					</div>
				</div>
				<div className="rightWallpaper" />
			</Modal>
		);
	}
}
export { SearchPopup };
